import React, { useEffect, useMemo, useState } from "react";
import dashboardHeader from "../../../../assets/icons/dashboard-header.png";
import "./dashboard-header-section.scss";
import { getCurrentTenantId } from "../../../../utils/utils";
import { getCurrentUser } from "../../../../common/routines/user-operations";
import { getUserDetails } from "../../../../api/settings";
import { useSetLoading } from "../../../../common/hooks/appearance";

const DashboardHeaderSection: React.FC = () => {
  const [profile, setProfile] = useState<any>(null);

  const [loading, setLoading] = useState<boolean>(false);

  const tenantId = getCurrentTenantId();
  const currentUser = getCurrentUser();
  const userId = currentUser?.id;
  const fetchUserProfile = async () => {
    setLoading(true);
    try {
      const response = await getUserDetails(userId);
      setProfile(response.data?.data?.data?.data);
    } catch (error: any) {
      console.error("Error fetching user profile:", error);
      return null;
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUserProfile();
  }, [tenantId]);

  const userInfo = profile?.find((user: any) => userId === user?.id);

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  return (
    <div className="dashboard-header-section">
      <div className="dashboard-header-section-right">
        <div className="dashboard-header-section-right-main">
          Welcome, {userInfo?.first_name || "-"}
        </div>
        <div className="dashboard-header-section-right-sub">
          Manage leads, track progress, and stay organized — all in one place.
        </div>
      </div>
      <div className="dashboard-header-section-left">
        <img src={dashboardHeader} alt="dashboardHeader"className="dashboard-header-image"/>
      </div>
    </div>
  );
};
export default DashboardHeaderSection;
